import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import axios from 'axios';
import ThankYouSkeleton from './skeletons/ThankYouSkeleton';

const ThankYouPage = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [confirmationMethod, setConfirmationMethod] = useState(null);

  useEffect(() => {
    // Retrieve confirmation method from localStorage
    const lastOrder = localStorage.getItem('lastOrderInfo');
    if (lastOrder) {
      const { method } = JSON.parse(lastOrder);
      setConfirmationMethod(method);
    }
  }, []);

  useEffect(() => {
    if (orderId) {
      axios
        .get(`/api/direct-orders/invoice/${orderId}`)
        .then((res) => {
          setOrderData(res.data);
          setLoading(false);
        })
        .catch((err) => {
          console.error('Failed to fetch order:', err);
          setLoading(false);
        });
    }
  }, [orderId]);
  if (loading) return <ThankYouSkeleton />;

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 pt-20 pb-32">
      <div className="bg-white shadow-lg rounded-lg p-8 max-w-2xl w-full">
        <div className="text-center">
          <CheckCircleIcon className="w-16 h-16 mx-auto text-green-500 mb-4" />
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Thank you for your order!</h1>

          {loading ? (
  <ThankYouSkeleton />
) : (
            <>
              <p className="text-gray-600 mb-1">
                <strong>Order ID:</strong> {orderData?.orderId || 'N/A'}
              </p>
              <p className="text-gray-500 mb-4">
                {confirmationMethod === 'email' ? (
                  <>
                    A confirmation email has been sent to your email. We’ll contact you soon with delivery details.
                  </>
                ) : (
                  <>
                    A confirmation message has been sent to your phone. We’ll contact you soon with delivery details.
                  </>
                )}
              </p>
            </>
          )}
        </div>

        {!loading && orderData?.items && (
          <div className="mt-4 border-t pt-4">
            <h3 className="text-lg font-semibold mb-3">Order Summary</h3>
            <ul className="divide-y">
              {orderData.items.map((item, idx) => (
                <li key={idx} className="py-3 flex items-center gap-4">
                  <img
                    src={`/uploads/${item.photo.replace(/\\/g, '/')}`}
                    alt={item.name}
                    className="w-16 h-16 object-cover rounded border"
                  />
                  <div className="flex-1">
                    <p className="font-semibold">{item.name}</p>
                    {item.size && (
                      <p className="text-sm text-gray-500">Size: {item.size}</p>
                    )}
                    <p className="text-sm text-gray-500">Qty: {item.quantity}</p>
                  </div>
                  <p className="font-semibold">
                    ${(item.price * item.quantity).toFixed(2)}
                  </p>
                </li>
              ))}
            </ul>
            <div className="text-right mt-4 text-lg font-bold">
              Total: ${parseFloat(orderData.totalPrice).toFixed(2)}
            </div>
          </div>
        )}

<div className="text-center mt-8 flex flex-col sm:flex-row justify-center gap-4">
  <Link
    to="/my-orders"
    className="bg-green-600 text-white px-6 py-3 rounded-md hover:bg-green-700 transition"
  >
    View My Orders
  </Link>

  <Link
    to="/shop"
    className="bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition"
  >
    Continue Shopping
  </Link>
</div>
      </div>
    </div>
  );
};

export default ThankYouPage;
